import { create } from "zustand";
import type { Brigade } from "../types";

interface BrigadeState {
	modalOpen: boolean;
	editingItem: Brigade | null;
	defaultOrganizationId: string | null;
}

interface BrigadeActions {
	openCreateModal: (organizationId?: string) => void;
	openEditModal: (item: Brigade) => void;
	closeModal: () => void;
}

type BrigadeStore = BrigadeState & BrigadeActions;

export const useBrigadeStore = create<BrigadeStore>((set) => ({
	modalOpen: false,
	editingItem: null,
	defaultOrganizationId: null,

	openCreateModal: (organizationId) => {
		set({ modalOpen: true, editingItem: null, defaultOrganizationId: organizationId ?? null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null, defaultOrganizationId: null });
	},
}));
